import React from 'react'

const Flag = (flagImg) => (
    <>
        <img src={flagImg} height={25} width={25}/>
    </>
)

export default Flag